import { Component, input, output } from '@angular/core';
import { ZiroIcons } from '../../../../shared/models/ziro-icons.enum';

@Component({
  selector: 'ziro-service-tile-add',
  templateUrl: './service-tile-add.component.html',
  styleUrls: ['./service-tile-add.component.scss'],
  standalone: false,
})
export class ZiroServiceTileAddComponent {
  readonly isEnabled = input<boolean>();
  readonly tooltip = input<string>();
  readonly icon = input<string>();
  readonly serviceName = input<string>();
  readonly isAdding = input(false);
  readonly isDeleted = input<boolean>();
  readonly isInProgress = input<boolean>();
  readonly isInProgressBadgeText = input<string>();

  readonly addTileClicked = output();

  ziroIcons = ZiroIcons;

  onTileClicked(): void {
    this.addTileClicked.emit();
  }
}
